// import { FontLoader } from 'qunar-react-native';
// FontLoader.loadFontSet(require('../../assets/QFontSet.js'));
import React, { Component } from 'react';
import { View } from 'react-native';
import { Provider, observer } from 'mobx-react/native';
import RootStore, { SearchResultStoreModel } from '../../Store/SearchResult/index';
import OrderList from '../OrderList/index';
import { Colors } from '@qnpm/q-theme';

const { scenes: { baseColor } } = Colors;

interface SearchListViewInterface {
    source?: string;
    ordertoken?: string;
    queryYear?: number;
    businessType?: string;
}
@observer
class SearchListView extends Component<SearchListViewInterface> {
    public rootStore: SearchResultStoreModel;
    public constructor(props: any) {
        super(props);
        this.rootStore = new RootStore();
    }
    public componentDidMount() {
        const {
            source: sourceFrom = 'list',
            ordertoken = '',
            queryYear,
            businessType: businessId = 'all'
        } = this.props;
        this.rootStore.setOrdertoken(ordertoken);
        this.rootStore.setQueryYear(queryYear);
        // 设置页面访问来源
        this.rootStore.uiState.setSourceFrom(sourceFrom);
        const isCold = false;
        this.rootStore.resetPage(businessId, isCold);
    }

    public render() {
        return (
            <Provider {...this.rootStore}>
                <View style={{ flex: 1, backgroundColor: baseColor.background2 }}>
                    <OrderList loadingOffset={{ top: -40 }} />
                </View>
            </Provider>
        );
    }
}

export default SearchListView;
